module.exports = __webpack_public_path__ + "static/media/comment-alt.d94a55b1.svg";